// Narrative door for the Capitolo III page: compares a SHA-256 of the typed key with the hash the theme setting prints.
// It is storytelling, not access control; reserved prices are enforced at checkout.
const STORAGE_KEY = 'cf-nebbia-key';

function readStored() {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeStored(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Private browsing can block storage; the door simply asks again next visit.
  }
}

async function sha256(text) {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}

class NebbiaGate extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.hash = this.dataset.keyHash || '';
    this.form = this.querySelector('[data-nebbia-form]');
    this.error = this.querySelector('[data-nebbia-error]');

    if (this.hasAttribute('data-open')) return;

    if (this.hash && readStored() === this.hash) {
      this.unlock(false);
      return;
    }

    this.form?.addEventListener('submit', (event) => this.onSubmit(event), { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async onSubmit(event) {
    event.preventDefault();
    const input = this.form.querySelector('input[name="nebbia-key"]');
    const value = input.value.trim().toLowerCase();
    if (!value) {
      this.showError(input);
      return;
    }

    const digest = await sha256(value);
    if (this.hash && digest === this.hash) {
      writeStored(this.hash);
      this.unlock(true);
    } else {
      this.showError(input);
    }
  }

  showError(input) {
    if (this.error) this.error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.focus();
    input.select();
  }

  unlock(moveFocus) {
    const door = this.querySelector('[data-nebbia-door]');
    const content = this.querySelector('[data-nebbia-content]');
    if (!content) return;

    const reveal = () => {
      if (door) door.hidden = true;
      content.hidden = false;
      if (moveFocus) {
        window.scrollTo({ top: 0 });
        content.querySelector('[data-nebbia-focus]')?.focus({ preventScroll: true });
      }
    };

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (moveFocus && !reduceMotion && document.startViewTransition) {
      document.startViewTransition(reveal);
    } else {
      reveal();
    }
  }
}

if (!customElements.get('s-nebbia-gate')) {
  customElements.define('s-nebbia-gate', NebbiaGate);
}
